import { createAction, props } from '@ngrx/store';
import { Merchant, User } from '@print2go/types';
import { UserInfo } from '@angular/fire/auth';

export const setAuthState = createAction(
  '[User] Set Auth State',
  props<{ user: UserInfo & Pick<User, 'emailVerified'> | null }>()
);
export const loadUser = createAction('[User] Load User');
export const loadUserSuccess = createAction('[User] Load User Success', props<{ user: Merchant }>());
export const loadUserFailure = createAction('[User] Load User Failure', props<{ error: any }>());
export const logoutUser = createAction('[User] Logout User');
export const updateUser = createAction(
  '[User] Update User',
  props<{ data: Partial<Merchant> & Pick<Merchant, 'uid'> }>()
);
export const updateUserSuccess = createAction('[User] Update User Success');
export const updateUserFailure = createAction('[User] Update User Failure', props<{ error: any }>());